import React, {Component} from 'react';
import './styles.css';
import CardHelper from "../../helpers";
import { Dates } from '../../../../packages/dates';
import Metadata from "../../../../requests/apa/Metadata";
import Assets from '../../../../requests/apa/Asset';
import Utils from '../../../../utils/Utils';
import DeviceStorage from '../../../DeviceStorage/DeviceStorage';
import EventTagCarrusel from '../../../../components/PersistentMiniEpg/EventTagCarrusel';
import { getCoverStyle, isPS4Platform, clearCoverRef } from '../ps4ImageUtils';

const _isPS4 = isPS4Platform();

class CardLastViewedChannel extends Component{
  constructor(props) {
    super(props);
    this.state = {
      showActions: props.showActions,
      imageReady: !_isPS4,
    };
    this.channelNumber = props.channelNumber;
    this.title = props.title;
    this.channelBlocked = props.channelBlocked;
    this.cover = props.cover;
    this.data = props.data;
    this.subtitle = props.subtitle;
    this.startTime = props.startTime;
    this.endTime = props.endTime;
    this.bookmark = props.bookmark;
    this.showActions = props.showActions;
    this.id = props.id;

    this.imageChannel = props.imageChannel;
    this.imageEvent = props.imageEvent;

    this.BlockedIcon = Assets.get('Homes_UltimosCanalesVistos_TarjetaEventosEnVivo_IconoBloqueado');
    this.FavoriteIcon = Assets.get('Homes_UltimosCanalesVistos_TarjetaEventosEnVivo_IconoFavorito');
    this.Tag_TextoTitulo_Ahora = Metadata.get('Tag_TextoTitulo_Ahora ', 'Tag_TextoTitulo_Ahora');
    this.Color_ColorAhora = Metadata.get('Color_ColorAhora', 'Color_ColorAhora');
    this.BarraDeProgreso_V2_ColorFondo = Metadata.get('BarraDeProgreso_V2_ColorFondo ', 'BarraDeProgreso_V2_ColorFondo');
    this.BarraDeProgreso_V2_ColorProgreso = Metadata.get('BarraDeProgreso_V2_ColorProgreso ', 'BarraDeProgreso_V2_ColorProgreso');
    this.Homes_UltimosCanalesVistos_TarjetaEventosEnVivo_ColorFondo = Metadata.get('Homes_UltimosCanalesVistos_TarjetaEventosEnVivo_ColorFondo ', 'Homes_UltimosCanalesVistos_TarjetaEventosEnVivo_ColorFondo');
    this.isBlockedChannel = Utils.isLiveEventPinBlocked(this.group_id);
    this.isfavoriredChannel = Utils.isFavoritedLiveEventPinBlocked(this.group_id);
    this.isOnlyOld = this._checkIsOnlyOld();

    this._coverRef = null;
    this._loadTimer = null;
    this._setCoverRef = this._setCoverRef.bind(this);

    // Cache
    this._cachedCoverStyle = null;
    this._prevCoverUrl = undefined;
    this._prevImageReady = undefined;
  }

  _checkIsOnlyOld() {
    const objectMeta = Metadata.get('adult_channel_rating','{"adult_channel_rating": {"default": {"rating_code": "NC-17","parental_rating": "+18"},"mexico": {"rating_code": "NC-17","parental_rating": "+18"}}}');
    let channelRatingMetadata = JSON.parse(objectMeta);
    const region = DeviceStorage.getItem('region');
    channelRatingMetadata = channelRatingMetadata.adult_channel_rating[region] || channelRatingMetadata.adult_channel_rating['default'];

    const eventData = this.props.data && this.props.data.event;
    const channelRatingEvent = eventData && eventData.parental_rating && eventData.parental_rating[0] && eventData.parental_rating[0].code;
    return channelRatingMetadata.parental_rating === channelRatingEvent && channelRatingMetadata.parental_rating === '+18';
  }

  componentDidMount() {
    if (!this.state.imageReady) {
      this._loadTimer = setTimeout(this._onImageReady, _isPS4 ? 200 : 150);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.showActions !== this.state.showActions){
      this.setState({showActions: nextProps.showActions});
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.state.showActions !== nextState.showActions ||
      this.state.imageReady !== nextState.imageReady
    );
  }

  componentWillUnmount() {
    if (this._loadTimer) {
      clearTimeout(this._loadTimer);
      this._loadTimer = null;
    }
    clearCoverRef(this._coverRef);
    this._coverRef = null;
    this._cachedCoverStyle = null;
  }

  _onImageReady = function() {
    this.setState({ imageReady: true });
  }.bind(this);

  _setCoverRef(el) {
    this._coverRef = el;
  }

  getStartEndTimeMovie(dateStr){
    return new Dates().unix(dateStr).format('HH:mm');
  }

  getDayAndMonth(dateStr){
    const date = new Date(dateStr * 1000);
    const formato = date.toLocaleDateString('es-ES', {
      day: 'numeric',
      month: 'short'
    });
    return formato;
  }

  render() {
    const eventData = this.data.event;
    const hStart = this.getStartEndTimeMovie(eventData.unix_begin);
    const hEnd = this.getStartEndTimeMovie(eventData.unix_end);
    const pgress = CardHelper.getTimeProgress(eventData.unix_begin, eventData.unix_end);

    // Actualizar cover style solo si cambió
    const coverUrl = this.isOnlyOld ? this.imageChannel : this.imageEvent;
    const imageReady = this.state.imageReady;
    if (coverUrl !== this._prevCoverUrl || imageReady !== this._prevImageReady) {
      this._prevCoverUrl = coverUrl;
      this._prevImageReady = imageReady;
      this._cachedCoverStyle = getCoverStyle(coverUrl, imageReady);
    }

    return (
      <div className='card card-last-viewed-livechannel'>
        <div className="card-header">
          <span className="channel-number">{this.channelNumber}</span>
          <span className="channel-name">{this.title}</span>
          {this.isBlockedChannel && <span className="bloked-icon">
              {this.BlockedIcon}
            </span>
            }
            {this.isfavoriredChannel && <span className="favorite-icon">
              {this.FavoriteIcon}
            </span>
            }
        </div>
        <div className={'card-container-lastView-channel'}>
          <div
            ref={this._setCoverRef}
            className='card-cover-lastView-channel'
            style={this._cachedCoverStyle}
          />
          {CardHelper.createProgressBarLastChannelViewed(pgress, this.BarraDeProgreso_V2_ColorFondo, this.BarraDeProgreso_V2_ColorProgreso)}
        </div>
        <div className="card-subtitle">{this.subtitle}</div>
          <div className="card-footer">
            <EventTagCarrusel
              wrapperId={'modal_1'}
              spanId={'modal_span_id'}
              style={{backgroundColor: this.Color_ColorAhora}}
              text = {this.Tag_TextoTitulo_Ahora}
            />
            <span className="time"> {hStart} - {hEnd}</span>
          </div>
      </div>
    );
  }
}

export default CardLastViewedChannel;



// WEBPACK FOOTER //
// ./src/components/CardNew/cardTypes/CardLastViewedChannel/index.js